// @flow
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Container, ImageSection, FormSection, Title } from './ForgotPassword.style';
import { ForgotPasswordForm } from './components';

type Props = {};
export type StateType = {
  setErrorMessage: String,
  setSuccessMessage: String,
  user: Object,
};
export type DispatchPropsType = {
  forgotPasswordRequest: Function,
};

class ForgotPassword extends Component<Props & StateType & DispatchPropsType> {
  componentDidMount() {
    const { user } = this.props;
    if (user) {
      const { history } = this.props;
      history.replace('/');
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user !== this.props.user) {
      const { user } = this.props;
      if (user && user.role) {
        const { history } = this.props;
        history.push('/');
      }
    }
  }

  render(): React$Element<any> {
    const { setErrorMessage, setSuccessMessage, forgotPasswordRequest } = this.props;
    return (
      <div>
        <div className="pt-32pt">
          <div className="container page__container d-flex flex-column flex-md-row align-items-center text-center text-sm-left">
            <div className="flex align-items-center mb-24pt mb-md-0">
              <div className="mb-24pt mb-sm-0 mr-sm-24pt">
                <h1 className="mb-0 text-center">Welcome to TACS</h1>
                <h3 className="mb-0 text-center">(Truck Access Control System)</h3>
              </div>
            </div>
          </div>
        </div>
        <Container>
          <FormSection>
            <div className="row mb-32pt">
              <div className="col-lg-4">
                <Title>
                  <div className="page-separator">
                    <div className="page-separator__text">Forgot Password</div>
                  </div>
                </Title>
                <ForgotPasswordForm
                  forgotPasswordRequest={forgotPasswordRequest}
                  setSuccessMessage={setSuccessMessage}
                  setErrorMessage={setErrorMessage}
                />
              </div>
              <ImageSection />
            </div>
          </FormSection>
        </Container>
      </div>
    );
  }
}

export default withRouter(ForgotPassword);
